import { DashboardView } from "../features/dashboard/dashboard-view";

export function DashboardPage(): JSX.Element {
  return <DashboardView />;
}
